import { defineMessages } from 'react-intl'

export default defineMessages({
  cancel: {
    id: 'containers.CustomerOrdersPage.components.OrderActionsButton.cancel',
    defaultMessage: 'Cancel',
  },
  duplicate: {
    id: 'containers.CustomerOrdersPage.components.OrderActionsButton.duplicate',
    defaultMessage: 'Duplicate',
  },
  edit: {
    id: 'containers.CustomerOrdersPage.components.OrderActionsButton.edit',
    defaultMessage: 'Edit',
  },
  view: {
    id: 'containers.CustomerOrdersPage.components.OrderActionsButton.view',
    defaultMessage: 'View',
  },
  actionsMenu: {
    id: 'containers.CustomerOrdersPage.components.OrderActionsButton.actionsMenu',
    defaultMessage: 'Open actions menu',
  },
})
